import { useSetRecoilState } from "recoil";

import Modal from "components/atoms/modal";
import { TextSm } from "components/atoms/text";
import Btn from "components/atoms/buttons";

import authAtom from "stores/auth";

interface Props {
  onClose: () => void;
}

// 일반회원이 샘플 신청 누를 시 안내
const ModalInquireGuide = ({ onClose }: Props) => {
  const setAuth = useSetRecoilState(authAtom);

  const handleClick = () => {
    localStorage.removeItem("TOKEN");
    setAuth({ isLogin: false, type: "" });
    window.location.href = "/signup";
  };

  return (
    <Modal.Container className="w-[312px] p-10 rounded-16 text-center">
      <TextSm className="text-black-60% mb-5">
        전문가 회원만 샘플 신청이 가능합니다.
        <br />
        회원 가입 페이지로 이동할까요?
      </TextSm>
      <div className="flex gap-5 mt-9">
        <Btn.Gray onClick={onClose} size="large" className="flex-1">
          취소
        </Btn.Gray>
        <Btn.Blue onClick={handleClick} size="large" className="flex-1">
          확인
        </Btn.Blue>
      </div>
    </Modal.Container>
  );
};

export default ModalInquireGuide;
